import React, { useState } from "react";
import Notification from "../components/Notification";
import { useAuthContext } from "../context/AuthContext";
import DownloadButton from "../components/downloadButton";
import { columns } from "../components/aadeSigners/AadeSignersColumns";
import DeleteConfirmationDialog from "../components/aadeSigners/DeleteDialog";
import AddDialog from "../components/aadeSigners/AddDialog";
import AddButton from "../components/aadeSigners/AddButton";
import SaveButton from "../components/aadeSigners/SaveButton";
import TableForSigneres from "../components/aadeSigners/TableForSigneres";
import { Box } from "@mui/material";

const AadeSigners = () => {
  const [signers, setSigners] = useState([]);
  const [selectedAfm, setSelectedAfm] = useState(null);
  const [deletedAfms, setDeletedAfms] = useState([]);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isAddDialogOpen, setAddDialogOpen] = useState(false);
  const [newSigners, setNewSigners] = useState([]);
  const { loading, setLoading, notification, setNotification } =
    useAuthContext();

  return (
    <Box>
      {signers.length >= 0 && (
        <>
          <Box
            sx={{
              textAlign: { xs: "center", md: "start" },
              marginTop: "5em",
              marginLeft: { xs: "0em", md: "12em" },
              marginBottom: "5em",
            }}
          >
            <h2>Προβολή και Δήλωση Υπογράφοντων</h2>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { xs: "100%", md: "40%" },
              margin: "auto",
              gap: "1em",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                margin: "auto",
                gap: "1em",
              }}
            >
              <TableForSigneres
                columns={columns}
                signers={signers}
                deletedAfms={deletedAfms}
                setSigners={setSigners}
                setSelectedAfm={setSelectedAfm}
                setDeleteDialogOpen={setDeleteDialogOpen}
                setNotification={setNotification}
                setDeletedAfms={setDeletedAfms}
                fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/tableActiveSigners`}
              />
            </Box>
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: "1em",
                width: "100%",
                margin: "auto",
                marginTop: "1em",
              }}
            >
              <AddButton
                signers={signers}
                deletedAfms={deletedAfms}
                setAddDialogOpen={setAddDialogOpen}
              />
              <DownloadButton
                downloadUrl={`${process.env.REACT_APP_BACKEND_URL}/downloadTableActiveSigners`}
                filename="Λίστα"
                buttonText="Λήψη Αρχείου"
                disabled={loading}
              />
              <SaveButton
                deletedAfms={deletedAfms}
                newSigners={newSigners}
                loading={loading}
                setNotification={setNotification}
                setLoading={setLoading}
                signers={signers}
              />
            </Box>
          </Box>
          <AddDialog
            setSigners={setSigners}
            setNewSigners={setNewSigners}
            setAddDialogOpen={setAddDialogOpen}
            isAddDialogOpen={isAddDialogOpen}
            signers={signers}
            newSigners={newSigners}
          />
          <DeleteConfirmationDialog
            isOpen={isDeleteDialogOpen}
            selectedAfm={selectedAfm}
            signers={signers}
            newSigners={newSigners}
            setSigners={setSigners}
            setNewSigners={setNewSigners}
            setSelectedAfm={setSelectedAfm}
            setDeletedAfms={setDeletedAfms}
            setDeleteDialogOpen={setDeleteDialogOpen}
          />
          <Notification
            notificationData={notification}
            setNotificationData={setNotification}
          />
        </>
      )}
    </Box>
  );
};

export default AadeSigners;
